import { IHrefNavItem, ILinkNavItem, IMenuNavItem, ISubmenuNavItem } from '@web_opxp/components';
import { LanguageService } from '@web_opxp/features';
import * as HistoryService from '../../base/historyService';
import { getBlogUrl, getSubscribePageUrl } from '../../base/historyService';
import { DashboardRoute } from '../../dashboard/Dashboard';
import { EvaluationRoute } from '../../evaluation';

const MenuStart: ILinkNavItem = {
  kind: 'link',
  link: DashboardRoute,
  label: 'common:Header.Menu.Training',
};

const MenuAchievements: ILinkNavItem = {
  kind: 'link',
  link: '/achievements',
  label: 'common:Header.Menu.Achievements',
};

const MenuCfq: ILinkNavItem = {
  kind: 'link',
  link: `${EvaluationRoute}/cfq`,
  label: 'common:Header.Menu.SelfAssessment',
};

const MenuStatistics: ILinkNavItem = {
  kind: 'link',
  link: `${EvaluationRoute}/statistics`,
  label: 'common:Header.Menu.Statistics',
};

const MenuOverview: ILinkNavItem = {
  kind: 'link',
  link: EvaluationRoute,
  label: 'common:Header.Menu.TrainingOverview',
};

const MenuProgress: ILinkNavItem = {
  kind: 'link',
  link: `${EvaluationRoute}/performance`,
  label: 'common:Header.Menu.Evaluation',
};

const MenuExtra: ILinkNavItem = {
  kind: 'link',
  link: '/extras',
  label: 'common:Header.Menu.Extras',
};

function getBlogMenuItem(language: string): IHrefNavItem {
  const blogUrl = getBlogUrl(language);
  return {
    kind: 'href',
    link: blogUrl,
    label: LanguageService.getTFunction()('common:Header.Menu.Blog'),
  };
}

function getProgressSubmenu(): ISubmenuNavItem {
  const items = [MenuOverview, MenuProgress, MenuCfq, MenuStatistics, MenuAchievements];
  return {
    kind: 'menu',
    label: LanguageService.getTFunction()('common:Header.Menu.Progress'),
    link: HistoryService.getInternalUrl(EvaluationRoute),
    items: items.map((i) => ({ ...i, label: LanguageService.getTFunction()(i.label) })),
  };
}

function getBaseMenu() {
  const start = {
    ...MenuStart,
    label: LanguageService.getTFunction()(MenuStart.label),
  };
  const extras = {
    ...MenuExtra,
    label: LanguageService.getTFunction()(MenuExtra.label),
  };
  return [start, getProgressSubmenu(), extras];
}

function getPremiumMenuItem(language: string, token?: string): IHrefNavItem {
  const subscribePageUrl = getSubscribePageUrl(language, token);
  return {
    kind: 'href',
    link: subscribePageUrl,
    label: LanguageService.getTFunction()('common:Header.Menu.Premium'),
  };
}

const getUserItem = (
  label: string,
  items: IMenuNavItem[],
  badge?: string | number,
  avatar?: string
): ISubmenuNavItem => ({
  kind: 'menu',
  label,
  items,
  badge,
  avatar,
});

const getFreemiumMenu = (
  language: string,
  userLabel = '',
  userItems: IMenuNavItem[] = [],
  userBadge?: string | number,
  userAvatar?: string,
  token?: string
): IMenuNavItem[] => {
  const baseMenu = getBaseMenu();
  const premiumItem = getPremiumMenuItem(language, token);
  const blogItem = getBlogMenuItem(language);
  return [...baseMenu, premiumItem, blogItem, getUserItem(userLabel, userItems, userBadge, userAvatar)];
};

const getPremiumMenu = (
  language: string,
  userLabel = '',
  userItems: IMenuNavItem[] = [],
  userBadge?: string | number,
  userAvatar?: string
): IMenuNavItem[] => {
  const baseMenu = getBaseMenu();
  const blogItem = getBlogMenuItem(language);
  return [...baseMenu, blogItem, getUserItem(userLabel, userItems, userBadge, userAvatar)];
};

export const getMenu = (
  premium: boolean,
  language: string,
  token: string | undefined,
  userLabel = '',
  userItems: IMenuNavItem[] = [],
  userBadge?: string | number,
  userAvatar?: string
) => {
  const menu: IMenuNavItem[] = premium
    ? getPremiumMenu(language, userLabel, userItems, userBadge, userAvatar)
    : getFreemiumMenu(language, userLabel, userItems, userBadge, userAvatar, token);
  return menu;
};
